import * as React from 'react';
import InfoNote from 'components/info-note/InfoNote';

interface Props {
  text: string,
  additionalClass?: string
}

const WarningBar = ({ text, additionalClass }: Props): JSX.Element => (
  <div
    className={
      additionalClass
        ? `organization-billing__warning-bar-container ${additionalClass}`
        : 'organization-billing__warning-bar-container'
      }
  >
    <InfoNote type="error">
      {text}
    </InfoNote>
  </div>
);

export default WarningBar;
